import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

const LandingPage = () => {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <div className="container mt-5 p-4 shadow-lg bg-light rounded" style={{ maxWidth: "900px" }}>
      <header className="text-center mb-5">
        <h1 className="text-primary fw-bold">YPO Carbon Calculator – Fly Carbon Neutral</h1>
        <p className="text-muted">Powered by <strong>BlocCarbon</strong></p>
      </header>

      <section className="mb-5">
        <p>
          Make Your Travel Carbon Neutral. YPO members can now measure the carbon footprint of their
          flights and offset it with two carefully selected carbon projects. This ensures that your travel remains
          sustainable and environmentally responsible.
        </p>
      </section>

      <section className="mb-5">
        <h2 className="text-secondary fw-bold">How It Works</h2>
        <ol className="list-group list-group-numbered">
          <li className="list-group-item">
            <strong>Measure Your Carbon Footprint</strong>
            <ul>
              <li>Enter your departure and arrival airports.</li>
              <li>Our tool calculates your flight emissions accurately.</li>
            </ul>
          </li>
          <li className="list-group-item">
            <strong>Offset Your Emissions</strong>
            <ul>
              <li>GIS have selected from two high-impact, verified carbon offset projects.</li>
              <li>Instantly neutralize your travel footprint.</li>
            </ul>
          </li>
          <li className="list-group-item">
            <strong>Travel Responsibly</strong>
            <ul>
              <li>Receive a certificate confirming your carbon-neutral journey.</li>
              <li>Support sustainability while traveling.</li>
            </ul>
          </li>
        </ol>
      </section>

      <section className="mb-5">
        <h2 className="text-secondary fw-bold">Why Offset Your Carbon?</h2>
        <p>
          Air travel is one of the highest contributors to individual carbon footprints. By offsetting your
          emissions, you help fund carbon-reducing projects that not only lower global emissions but also
          support local communities.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-secondary fw-bold">Offset Projects</h2>
        <p>
          Our selected projects are Gold Standard or VCS-certified, ensuring that your contributions make a
          real impact. These projects not only reduce carbon but also provide social and economic benefits to
          local communities.
        </p>
        <ol className="list-group list-group-numbered">
          <strong>Projects</strong>
          <ul>
            <li>
              <a href="/pdfs/Vietnam Improved Cookstove.pdf" target="_blank" rel="noopener noreferrer">
                Vietnam Improved Cookstove
              </a>
            </li>
            <li>
              <a href="/pdfs/Biogas Project.pdf" target="_blank" rel="noopener noreferrer">
                Biogas Project
              </a>
            </li>
          </ul>
        </ol>
      </section>

      <section className="mb-5">
        <h2 className="text-secondary fw-bold">YPO Event Carbon Footprint</h2>
        <p>
          In addition to individual flight calculations, we are collaborating with YPO Chapters and Event
          Management teams to assess and offset the carbon footprint of YPO events. This initiative helps
          ensure that YPO gatherings are aligned with our sustainability goals.
        </p>
      </section>

      <section className="mb-5">
        <h2 className="text-secondary fw-bold">YPO GIS Summit Vietnam Flight Carbon Calculator</h2>
        <p>
            As part of our commitment to sustainability and responsible leadership, 
            YPO / YNG is proud to introduce the Flight Carbon Calculator for 
            the upcoming Global Impact Summit (GIS) in Vietnam.
        </p>
        <p>
            This tool allows all summit attendees to measure the carbon footprint 
            of their flights to and from Vietnam and offset it through verified, 
            high-impact carbon projects.
        </p>
      </section>

      <section className="mb-5">
        <h2 className="text-secondary fw-bold">Join Us in Making a Difference</h2>
        <p>
          Use the YPO Carbon Calculator today and be part of a movement towards sustainable travel.
        </p>
      </section>

      <footer className="text-center">
        <button
          className="btn btn-primary btn-lg"
          onClick={() => navigate('/calculator')} // Navigate to the calculator page
        >
          <i className="bi bi-arrow-right-circle"></i> Go to Carbon Calculator
        </button>
      </footer>
    </div>
  );
};

export default LandingPage;